import { Lock, MapPin, MessageCircle, Video } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { WHATSAPP_URL, scrollToId, trackClick } from "../../lib/site";

export const FinalCta = () => (
  <>
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-brand py-24 lg:py-32"
    >
      <div className="pointer-events-none absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full bg-clay/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-32 h-[420px] w-[420px] rounded-full bg-sand/8 blur-3xl" />

      <div className="relative mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <Overline light>Dê o primeiro passo</Overline>
          <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-sand sm:text-5xl lg:text-6xl">
            Sua história merece um espaço de{" "}
            <span className="italic text-clay">escuta</span>.
          </h2>
          <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-sand/75 sm:text-lg">
            Se você busca um acompanhamento ético, humano e baseado em
            evidências, será um prazer caminhar ao seu lado nesse processo.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col items-center gap-2 text-center">
            <p className="inline-flex items-center gap-2 rounded-full bg-sand/10 px-6 py-2.5 text-sm font-semibold text-clay">
              Agenda aberta para novos pacientes
            </p>
            <p className="text-sm text-sand/60">
              Respondo pessoalmente, em horário comercial — geralmente no mesmo dia
            </p>
          </div>
          <div className="mt-10">
            <a
              data-testid="final-cta-button"
              href={WHATSAPP_URL}
              onClick={() => trackClick("final")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-full bg-sand px-10 py-5 text-base font-semibold text-brand shadow-[0_20px_48px_rgba(0,0,0,0.25)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-white"
            >
              <MessageCircle className="h-5 w-5 text-wa" />
              Converse comigo no WhatsApp
            </a>
            <div className="mt-6 flex justify-center">
              <p
                data-testid="final-confidentiality-note"
                className="inline-flex items-center gap-2 text-sm font-medium text-sand/80"
              >
                <Lock className="h-4 w-4 text-clay" strokeWidth={1.8} />
                Sigilo garantido pelo Código de Ética do Psicólogo
              </p>
            </div>
            <p className="mt-3 text-xs font-medium uppercase tracking-[0.2em] text-sand/50">
              Atendimento com hora marcada · Sem compromisso no primeiro contato
            </p>
          </div>
        </Reveal>
      </div>
    </section>

    <footer data-testid="site-footer" className="bg-bark py-14 text-sand/70">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-6 lg:flex-row lg:items-center lg:px-10">
        <div>
          <p className="font-serif text-2xl font-semibold text-sand">
            Vanessa Calsavara
          </p>
          <p className="mt-1 text-xs font-semibold uppercase tracking-[0.24em] text-sand/50">
            Psicóloga · CRP 06/148265 · Terapia Sistêmica Familiar
          </p>
          <div className="mt-5 flex flex-col gap-2 text-sm">
            <span className="inline-flex items-center gap-2">
              <MapPin className="h-4 w-4 text-clay" /> São José do Rio Preto/SP
            </span>
            <span className="inline-flex items-center gap-2">
              <Video className="h-4 w-4 text-clay" /> Atendimento online para todo o Brasil
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3 text-sm">
          <a
            data-testid="footer-whatsapp-link"
            href={WHATSAPP_URL}
            onClick={() => trackClick("rodape")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-semibold text-sand transition-colors duration-300 hover:text-clay"
          >
            <MessageCircle className="h-4 w-4 text-wa" /> (17) 99135-6298
          </a>
          <button
            data-testid="footer-faq-link"
            onClick={() => scrollToId("#duvidas")}
            className="text-left transition-colors duration-300 hover:text-clay"
          >
            Dúvidas frequentes
          </button>
          <button
            data-testid="footer-about-link"
            onClick={() => scrollToId("#sobre")}
            className="text-left transition-colors duration-300 hover:text-clay"
          >
            Sobre mim
          </button>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-sand/10 px-6 pt-8 lg:px-10">
        <p className="text-xs leading-relaxed text-sand/40">
          © {new Date().getFullYear()} Vanessa Calsavara — Psicóloga. Todos os
          direitos reservados. Este site tem caráter informativo e não substitui
          atendimento de urgência. Em caso de crise, ligue 188 (CVV — Centro de
          Valorização da Vida) ou procure o serviço de emergência mais próximo.
        </p>
      </div>
    </footer>
  </>
);
